import { AccessServiceBase, WsAccess } from "./wsdl/ws_access/v1.17/ws_access";

export {
    WsAccess
};

export class AccessService extends AccessServiceBase {
}
